import { Drawer, Theme, styled } from "@mui/material";
import { CSSProperties } from "@mui/material/styles/createMixins";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSProperties => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSProperties => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)})`,
    [theme.breakpoints.up("sm")]: {
        width: `calc(${theme.spacing(9)})`,
    },
});

// @ts-ignore
export const DrawerStyled = styled(Drawer)(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && { ...openedMixin(theme) }),
    "& .MuiDrawer-paper": open ? { ...openedMixin(theme) } : { ...closedMixin(theme) },
    ...(!open && { ...closedMixin(theme) }),
}));

// @ts-ignore
export const ToolbarIcon = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
}));
